import { Schema } from "@comparaonline/products-schema";

import { getReviewSummary, getDetailUrl } from "../../../../../models/product";
import { REVIEW_SECTION_ID } from "../../../../productDetail/constants";
import { useAppContext } from "../../../../../lib/appContext";

export const useRatingProps = () => {
  const { businessUnitSlug, countryCode } = useAppContext();
  return (product: Schema.ProductListProduct) => {
    const reviewSummary = getReviewSummary(product);
    return reviewSummary
      ? {
          count: reviewSummary.total,
          href: `${getDetailUrl(countryCode, businessUnitSlug, product)}#${REVIEW_SECTION_ID}`,
          ratingProps: {
            initialRating: reviewSummary.averageValue
          }
        }
      : null;
  };
};
